"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsectValueTypePrefixes = void 0;
const INSECT_TRAP_CATCHES_VALUE_KEY_PREFIX = 'insectTrapCatches_';
const INSECT_TRAP_CATCHES_PERCENTAGE_VALUE_KEY_PREFIX = 'insectTrapCatchesPercentage_';
const INSECT_LARVAL_TREND_VALUE_KEY_PREFIX = 'insectLarvalTrend_';
const INSECT_DEGREE_DAY_VALUE_KEY_PREFIX = 'insectDegreeDaysCumulativeSinceBiofix_';
const INSECT_PHENOLOGY_VALUE_KEY_PREFIX = 'insectPhenology_';
const INSECT_DEGREE_DAY_RAW_VALUE_KEY_PREFIX = 'insectDegreeDays_';
exports.InsectValueTypePrefixes = {
    INSECT_TRAP_CATCHES_VALUE_KEY_PREFIX,
    INSECT_TRAP_CATCHES_PERCENTAGE_VALUE_KEY_PREFIX,
    INSECT_LARVAL_TREND_VALUE_KEY_PREFIX,
    INSECT_DEGREE_DAY_VALUE_KEY_PREFIX,
    INSECT_DEGREE_DAY_RAW_VALUE_KEY_PREFIX,
    INSECT_PHENOLOGY_VALUE_KEY_PREFIX,
};
//# sourceMappingURL=insectValueTypes.js.map